module.exports = __webpack_public_path__ + "img/location-pin-a.0ccbdaf0.png";